import { ButtonGroup } from "@elit-hair/elit-ui";
import { IconType } from "react-icons";
import { TbPhone } from "react-icons/tb";

import { KpiData } from "@/types/call.types";
import { formatDuration } from "@/utils/format-duration";

import { HeaderKpiItem } from "./item";
import { HeaderKpiSkeleton } from "./skeleton";

type KpiRowProps = {
    kpiData?: KpiData | null;
    className?: string;
};

export function KpiRow({ kpiData, className }: KpiRowProps) {
    const items: { value: string; label: string | IconType; translation: string }[] = [
        { value: kpiData?.all.toString() ?? "", label: "All", translation: "all_brutto" },
        { value: kpiData?.bruttos.toString() ?? "", label: "B", translation: "brutto" },
        { value: kpiData?.netto.toString() ?? "", label: "N", translation: "netto" },
        {
            value: formatDuration(kpiData?.inCallTime ?? 0),
            label: TbPhone,
            translation: "in_call_time",
        },
    ];

    return (
        <ButtonGroup className={className} aria-label="KPI metrics">
            {!kpiData && Array.from({ length: items.length }).map((_, index) => <HeaderKpiSkeleton key={index} />)}
            {kpiData &&
                items.map((item) => (
                    <HeaderKpiItem
                        key={item.translation}
                        value={item.value}
                        label={item.label}
                        translation={item.translation}
                    />
                ))}
        </ButtonGroup>
    );
}
